<div
    class="p-2 rounded-md flex gap-4 items-center relative"
    [ngClass]="{
        'hover:bg-light-200': state === FeatureState.ENABLED,
        'cursor-pointer': state === FeatureState.ENABLED || (about && !expanded),
        'text-dark-300 cursor-default': state !== FeatureState.ENABLED,
        'bg-brand-50 text-brand': active,
        'text-dark': !active,
    }"
    [matTooltipDisabled]="expanded"
    [matTooltip]="getMenuItemTooltip(category, title, state)"
    [matTooltipPosition]="'right'"
>
    <myrtls-icon [icon]="icon || 'arrow_right'"></myrtls-icon>
    @if (badge && !expanded) {
        <div class="text-xs absolute -top-2 -right-1 bg-info-500 rounded-full px-1 text-light-50">new</div>
    }
    @if (expanded) {
        <div class="grow flex items-center font-light">{{ title }}</div>
    }
    @if (state !== FeatureState.ENABLED) {
        <myrtls-icon
            class="text-error"
            (click)="iconClick($event, about)"
            [ngClass]="{ 'absolute bottom-0 right-0 bg-white rounded-full p-1': !expanded, 'cursor-pointer': about && expanded }"
            [matTooltipDisabled]="!expanded"
            [matTooltip]="getIconTooltip(state)"
            [matTooltipPosition]="'right'"
            [icon]="getIcon(state) || 'arrow_right'"
            [size]="expanded ? 'md' : 'sm'"
        ></myrtls-icon>
    }
</div>
